import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Collapse, LinearProgress, Typography } from "@mui/material";

import { Review, ReviewSkill } from "../../../../../types/types";
import { testimonialStyles } from "../styles";

const TestimonialCardBody = ({ review }: { review: Review }) => {
  const { t } = useTranslation("profiles", { keyPrefix: "testimonials" });
  const [expanded, setExpanded] = useState(false);

  const {
    reviewInfo: { review: reviewText },
    endorsedSkills,
  } = review;

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const initialSkills = endorsedSkills.slice(0, 4);
  const remainingSkills = endorsedSkills.slice(4);

  return (
    <Box sx={testimonialStyles.card.body.container}>
      <Typography sx={testimonialStyles.card.body.reviewText}>{reviewText}</Typography>
      <Box sx={testimonialStyles.card.body.skillsContainer}>
        {initialSkills?.map((skill, index) => (
          <SkillMeter key={index} reviewedSkill={skill} />
        ))}
        {remainingSkills?.length > 0 && (
          <>
            <Collapse in={expanded}>
              {remainingSkills?.map((skill, index) => (
                <SkillMeter key={index + 4} reviewedSkill={skill} />
              ))}
            </Collapse>
            <Button
              variant="text-sm"
              fullWidth
              onClick={handleExpandClick}
              sx={testimonialStyles.card.body.showMoreButton}
            >
              {expanded ? t("showLess") : t("showMore")}
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
};

export default TestimonialCardBody;

const SkillMeter = ({
  reviewedSkill: {
    percentage,
    skill: { name },
  },
}: {
  reviewedSkill: ReviewSkill;
}) => {
  return (
    <Box sx={testimonialStyles.card.skillMeter.container}>
      <Box sx={testimonialStyles.card.skillMeter.header}>
        <Typography sx={testimonialStyles.card.skillMeter.skillName}>{name}</Typography>
        <Typography sx={testimonialStyles.card.skillMeter.percentage}>{percentage || 0}%</Typography>
      </Box>
      <LinearProgress
        sx={testimonialStyles.card.skillMeter.progressBar}
        variant="determinate"
        value={percentage || 0}
      />
    </Box>
  );
};
